import { FC, useMemo } from 'react';

import clsx from 'clsx';
import { minidenticon } from 'minidenticons';

import { PlayerType } from 'shared/types/app-types';

interface IAvatarProps {
  userAddress: PlayerType['address'];
  className?: string;
}

export const Avatar: FC<IAvatarProps> = ({ userAddress, className = 'w-8 h-8' }) => {
  const svgURI = useMemo(
    () => 'data:image/svg+xml;utf8,' + encodeURIComponent(minidenticon(userAddress)),
    [userAddress],
  );
  return (
    <div className={clsx('flex flex-col bg-[#112969]', className)}>
      <img src={svgURI} alt="Avatar" className="h-full w-full" />
    </div>
  );
};
